/**
 * Fellheimat - Gratis-Geschenk als Line-Item-Property am Geschirr
 *
 * WARUM DAS GESCHENK KEINE EIGENE BESTELLPOSITION IST
 * Frueher legte dieses Skript die Leine als eigene Warenkorbzeile ein und eine
 * BXGY-Rabattregel machte sie kostenlos. Damit stand sie als zweite Position in
 * der Bestellung - und CJ-Dropshipping verlangte fuer sie einen eigenen
 * Versand, obwohl die Leine dem Geschirr bei CJ ohnehin beiliegt. Folge:
 * Bestellung von Hand teilen, zwei Fulfillments, zwei Lieferungen im
 * Order-Tracking. Nachweisbar an Bestellung #1003 vom 21.08.2026 - zwei
 * Fulfillments im Abstand von 27 Minuten, nur das erste mit Sendungsnummer.
 *
 * Jetzt haengt das Geschenk als Line-Item-Property am Geschirr. Die Optik im
 * Warenkorb liefert snippets/fh-gift-line.
 *
 * EINE LEINE JE BESTELLUNG (Stand 25.08.2026)
 * Mit der Mengenstaffel koennen mehrere Geschirre im Warenkorb liegen, teils
 * in verschiedenen Farben und damit als mehrere Zeilen. Es gibt trotzdem genau
 * EINE Leine. Deshalb traegt genau EINE Geschirrzeile die Property - die
 * erste - und alle weiteren werden von ihr befreit. Die Farbe entscheidet
 * dieselbe Regel wie in der Anzeige (siehe snippets/fh-gift-config):
 * fuehrt irgendein Geschirr auf die Mischfarbe, gilt die Mischfarbe, sonst die
 * Farbe des ersten Geschirrs.
 *
 * WARUM DIE PROPERTY BEIM EINZELKAUF IN HORIZONS EIGENEN REQUEST WANDERT
 * Horizon schickt beim Add-to-Cart
 *     POST /cart/add.js   Accept: text/html
 *     FormData: id, product-id, sections=cart-drawer-section
 * und laesst sich den fertig gerenderten Cart Drawer im selben Response
 * mitliefern. Der Body des laufenden Requests wird deshalb ergaenzt, statt
 * einen zweiten Request zu schicken.
 *
 * WARUM DAS BEIM PAKETKAUF NICHT GEHT
 * assets/fh-volume-tiers.js schreibt denselben Request auf items[]-Form um und
 * setzt quantity auf 0. Eine Property auf der obersten Ebene gehoert dann zu
 * keiner Position mehr und faellt weg. In diesem Fall wird hier bewusst nichts
 * angehaengt - reconcile() traegt sie 200 ms spaeter nach. Sichtbar ist das
 * nicht: die Geschenkzeile im Drawer leitet ihre Farbe aus den Varianten ab,
 * nicht aus der Property.
 *
 * DIE ANZEIGE HAENGT NICHT AN DIESEM SKRIPT
 * fh-gift-line leitet die Leinenfarbe aus den Geschirr-Varianten ab. Faellt das
 * Skript aus, sieht der Kunde sein Geschenk trotzdem - es fehlt nur die
 * Property fuer Checkout und Bestellbestaetigung.
 *
 * Eigene Requests laufen ueber nativeFetch und werden nicht abgefangen -
 * reconcile() kann sich also nicht selbst ausloesen.
 */
(function () {
  'use strict';

  var CONFIG = window.FH_FREE_GIFT || {};
  var TRIGGER_PRODUCT_ID = CONFIG.triggerProductId;
  var TRIGGER_VARIANTS = CONFIG.triggerVariants || {};
  var GIFT_PRODUCT_ID = CONFIG.giftProductId;
  var GIFT_TITLE = CONFIG.giftTitle || '';
  var PROP = CONFIG.propertyKey || 'Gratis dazu';
  var FALLBACK_COLOR = CONFIG.fallbackColor || '';
  var MIXED_COLOR = CONFIG.mixedColor || FALLBACK_COLOR;

  /* Property der alten Fassung. Nur noch zum Aufraeumen alter Warenkoerbe. */
  var LEGACY_PROP = '_fh_geschenk';

  if (!TRIGGER_PRODUCT_ID) return;

  var COLOR_MAP = (function (raw) {
    var map = {};
    String(raw || '').split(',').forEach(function (pair) {
      var parts = pair.split(':');
      if (parts.length === 2) map[parts[0].trim().toLowerCase()] = parts[1].trim();
    });
    return map;
  })(CONFIG.colorMap);

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?/;
  var CART_ADD = /\/cart\/add(\.js)?/;
  var FIELD = 'properties[' + PROP + ']';
  var nativeFetch = window.fetch.bind(window);

  /* Serialisiert alle eigenen Warenkorb-Operationen. Ein frueherer Ansatz mit
     einem busy-Flag hat Arbeit uebersprungen statt zu warten. */
  var pending = Promise.resolve();
  function queue(task) {
    var run = pending.then(task, task);
    pending = run.catch(function () {});
    return run;
  }

  /* --- Farbe und Beschriftung ---------------------------------------------- */

  function giftColorFor(harnessColor) {
    return COLOR_MAP[String(harnessColor || '').toLowerCase()] || FALLBACK_COLOR;
  }

  function giftLabel(color) {
    return color ? GIFT_TITLE + ' (' + color + ')' : GIFT_TITLE;
  }

  function colorOf(item) {
    var opts = item.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      if (/farbe|colour|color/i.test(opts[i].name)) return opts[i].value;
    }
    return null;
  }

  /**
   * Leinenfarbe fuer eine Liste von Geschirrfarben in Warenkorbreihenfolge.
   * Siehe snippets/fh-gift-config fuer die Herleitung.
   */
  function giftColorForColors(harnessColors) {
    if (!harnessColors.length) return FALLBACK_COLOR;
    var mapped = harnessColors.map(giftColorFor);
    for (var i = 0; i < mapped.length; i++) {
      if (mapped[i] === MIXED_COLOR) return MIXED_COLOR;
    }
    return mapped[0];
  }

  /* --- Warenkorb ----------------------------------------------------------- */

  function getCart() {
    return nativeFetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function postCart(path, payload) {
    return nativeFetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  /* --- Request-Analyse ----------------------------------------------------- */

  function readAddPayload(input, init) {
    var body = (init && init.body) || (input && input.body);
    if (!body) return null;
    try {
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return {
          variantId: body.get('id'),
          productId: body.get('product-id'),
          /* Von fh-volume-tiers umgeschrieben: quantity 0 und items[] statt
             einer einzelnen Position. */
          batch: body.has('items[0][id]') || String(body.get('quantity')) === '0'
        };
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return {
          variantId: body.get('id'),
          productId: body.get('product-id'),
          batch: body.has('items[0][id]') || String(body.get('quantity')) === '0'
        };
      }
      if (typeof body === 'string') {
        var j = JSON.parse(body);
        if (j.items && j.items.length) return { variantId: j.items[0].id, productId: null, batch: j.items.length > 1 };
        if (j.id) return { variantId: j.id, productId: null, batch: false };
      }
    } catch (e) {
      /* nicht auswertbar - dann uebernimmt reconcile() */
    }
    return null;
  }

  function isTriggerAdd(p) {
    if (!p) return false;
    if (p.productId && String(p.productId) === String(TRIGGER_PRODUCT_ID)) return true;
    if (p.variantId && TRIGGER_VARIANTS[String(p.variantId)]) return true;
    return false;
  }

  /* Ergaenzt den Body des laufenden Requests. Gibt false zurueck, wenn der Body
     nicht erreichbar ist - etwa weil er in einem Request-Objekt als Stream
     steckt. Dann traegt reconcile() die Property nach. */
  function attachProperty(args, label) {
    var init = args[1];
    var input = args[0];
    var body = (init && init.body) || (input && input.body);

    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      if (body.has(FIELD)) body.delete(FIELD);
      body.append(FIELD, label);
      return true;
    }

    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
      body.set(FIELD, label);
      return true;
    }

    if (typeof body === 'string' && init && typeof init === 'object') {
      try {
        var j = JSON.parse(body);
        var target = null;
        if (j.items && j.items.length) {
          target = j.items[0];
        } else if (j.id) {
          target = j;
        }
        if (!target) return false;
        target.properties = target.properties || {};
        target.properties[PROP] = label;
        init.body = JSON.stringify(j);
        return true;
      } catch (e) {
        return false;
      }
    }

    return false;
  }

  /* --- Nachlauf ------------------------------------------------------------ */

  function reconcile() {
    return getCart()
      .then(function (cart) {
        var items = cart.items || [];
        var ops = [];

        /* Alle Geschirrzeilen in Warenkorbreihenfolge. Die erste traegt die
           Property, alle weiteren duerfen sie nicht tragen. */
        var harness = items.filter(function (item) {
          return String(item.product_id) === String(TRIGGER_PRODUCT_ID);
        });
        var wantedLabel = harness.length
          ? giftLabel(giftColorForColors(harness.map(colorOf)))
          : '';

        items.forEach(function (item) {
          /* Altbestand aus der Zeit vor dem Umbau: eine eigenstaendige
             Geschenkzeile im Warenkorb eines wiederkehrenden Besuchers. Sie
             muss weg, sonst geht sie als zweite Position an CJ - und seit die
             Rabattregel abgeschaltet ist, zahlt der Kunde sie sogar. */
          if (
            GIFT_PRODUCT_ID &&
            String(item.product_id) === String(GIFT_PRODUCT_ID) &&
            item.properties &&
            item.properties[LEGACY_PROP]
          ) {
            ops.push({ id: item.key, quantity: 0 });
            return;
          }

          if (String(item.product_id) !== String(TRIGGER_PRODUCT_ID)) return;

          var wanted = item === harness[0] ? wantedLabel : '';
          var current = (item.properties && item.properties[PROP]) || '';
          if (current === wanted) return;

          /* Vorhandene Properties uebernehmen: /cart/change.js ersetzt die
             Sammlung vollstaendig, ein blosses Setzen wuerde fremde Werte
             loeschen - etwa die einer spaeter installierten App. */
          var props = {};
          var existing = item.properties || {};
          Object.keys(existing).forEach(function (key) {
            if (key === PROP) return;
            props[key] = existing[key];
          });
          if (wanted) props[PROP] = wanted;

          ops.push({ id: item.key, quantity: item.quantity, properties: props });
        });

        if (!ops.length) return null;

        /* Nacheinander: jede Aenderung schreibt den Warenkorb neu. */
        return ops.reduce(function (chain, op) {
          return chain.then(function () {
            return postCart('/cart/change.js', op);
          });
        }, Promise.resolve());
      })
      .catch(function () {});
  }

  /* --- fetch-Patch --------------------------------------------------------- */

  window.fetch = function (input, init) {
    var args = Array.prototype.slice.call(arguments);
    var url = typeof input === 'string' ? input : (input && input.url) || '';

    if (CART_ADD.test(url)) {
      var payload = readAddPayload(input, init);
      if (payload && !payload.batch && isTriggerAdd(payload)) {
        var color = giftColorFor(TRIGGER_VARIANTS[String(payload.variantId)]);
        attachProperty(args, giftLabel(color));
      }
    }

    var promise = nativeFetch.apply(null, args);
    if (CART_WRITE.test(url)) {
      promise
        .then(function () {
          setTimeout(function () {
            queue(reconcile);
          }, 200);
        })
        .catch(function () {});
    }
    return promise;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      queue(reconcile);
    });
  } else {
    queue(reconcile);
  }
})();
